import { Form } from "react-bootstrap";
import { FormControl, FormErrorMessage, FormLabel, Required } from "./Components";
import { ErrorMessage, Field, getIn } from "formik";
import { classNames } from "../../../helper";


export default function FormInput({type, label, forceLTR, isRequired, formik, noPaste, theme, ...props}){
    const { name } = props;
    const handlePaste = (e) => {
        if(noPaste)
          e.preventDefault();
    };
    return (
      <Form.Group className="mb-3">
        <Field name={name}>
          {({ field }) => {
              const error = getIn(formik.errors, field.name);
              const touch = getIn(formik.touched, field.name);
              return (
                <>
                    {label && <FormLabel>{label} {isRequired && <Required>*</Required>}</FormLabel>}
                    {type === "textarea"?(
                        <FormControl
                            {...props} className={(classNames([
                              "form-control", 
                              forceLTR?"ltr":"", 
                              theme?"input-"+theme:"",
                              touch && error ? "is-invalid" : ""
                            ]))}
                            isInvalid={touch && error}
                            {...field}
                            onPaste={handlePaste}
                            as="textarea"
                            rows={3}
                        />
                    ):(
                        <FormControl
                            type={type}
                            {...props} className={(forceLTR?"ltr":"")+" "+(theme?"input-"+theme:"")}
                            isInvalid={touch && error}
                            {...field}
                            onPaste={handlePaste}
                        />
                    )}
                    {touch && error && <ErrorMessage name={field.name}>
                        {(msg) => <FormErrorMessage type="invalid">{msg}</FormErrorMessage>}
                    </ErrorMessage>}
                </>
              )
          }}
        </Field>
      </Form.Group>
      
    )
}